import {
  FETCH_AI_CONVERSATIONS,
  FETCH_AI_CONVERSATIONS_SUCCESS,
  FETCH_AI_CONVERSATIONS_FAILURE,
  FETCH_AI_CONVERSATION,
  FETCH_AI_CONVERSATION_SUCCESS,
  FETCH_AI_CONVERSATION_FAILURE,
  CREATE_AI_CONVERSATION,
  CREATE_AI_CONVERSATION_SUCCESS,
  CREATE_AI_CONVERSATION_FAILURE,
  SEND_AI_MESSAGE,
  SEND_AI_MESSAGE_SUCCESS,
  SEND_AI_MESSAGE_FAILURE,
  APPEND_OPTIMISTIC_AI_MESSAGE,
  RESET_AI_CONVERSATION_STATE,
  FETCH_AI_LOGS,
  FETCH_AI_LOGS_SUCCESS,
  FETCH_AI_LOGS_FAILURE,
} from "./constants";

export const fetchAiConversations = (payload) => ({
  type: FETCH_AI_CONVERSATIONS,
  payload,
});
export const fetchAiConversationsSuccess = (payload) => ({
  type: FETCH_AI_CONVERSATIONS_SUCCESS,
  payload,
});
export const fetchAiConversationsFailure = (payload) => ({
  type: FETCH_AI_CONVERSATIONS_FAILURE,
  payload,
});

export const fetchAiConversation = (payload) => ({
  type: FETCH_AI_CONVERSATION,
  payload,
});
export const fetchAiConversationSuccess = (payload) => ({
  type: FETCH_AI_CONVERSATION_SUCCESS,
  payload,
});
export const fetchAiConversationFailure = (payload) => ({
  type: FETCH_AI_CONVERSATION_FAILURE,
  payload,
});

export const createAiConversation = (payload) => ({
  type: CREATE_AI_CONVERSATION,
  payload,
});
export const createAiConversationSuccess = (payload) => ({
  type: CREATE_AI_CONVERSATION_SUCCESS,
  payload,
});
export const createAiConversationFailure = (payload) => ({
  type: CREATE_AI_CONVERSATION_FAILURE,
  payload,
});

export const sendAiMessage = (payload) => ({ type: SEND_AI_MESSAGE, payload });
export const sendAiMessageSuccess = (payload) => ({
  type: SEND_AI_MESSAGE_SUCCESS,
  payload,
});
export const sendAiMessageFailure = (payload) => ({
  type: SEND_AI_MESSAGE_FAILURE,
  payload,
});

export const appendOptimisticAiMessage = (payload) => ({
  type: APPEND_OPTIMISTIC_AI_MESSAGE,
  payload,
});
export const resetAiConversationState = () => ({
  type: RESET_AI_CONVERSATION_STATE,
});

export const fetchAiLogs = (payload) => ({ type: FETCH_AI_LOGS, payload });
export const fetchAiLogsSuccess = (payload) => ({
  type: FETCH_AI_LOGS_SUCCESS,
  payload,
});
export const fetchAiLogsFailure = (payload) => ({
  type: FETCH_AI_LOGS_FAILURE,
  payload,
});
